import { render, staticRenderFns } from "./hot-sale-search.vue?vue&type=template&id=931bd610"
import script from "./hot-sale-search.vue?vue&type=script&lang=js"
export * from "./hot-sale-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports